import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { compose } from 'recompose'
import Divider from '@material-ui/core/Divider';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';
import AppContent from '../../../components/App/appContent';
import SingleColumnView from '../../../components/App/singleColumnView';
import Header from '../../../components/App/PageComponents/pageContentHeader';
import { AddCircle } from '@material-ui/icons';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import TextField from '@material-ui/core/TextField';
import { showSnackbar } from '../../../../actions/appActions'
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  paper: {
    padding: 30
  },
  divid: {
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  buttonIc: {
    marginTop: '8px',
    fontSize: '14px'
  }
})

const pageTitle = {
  title: 'New Mapping',
  subtitle: 'Create new Mapping',
  avatar: <ListItemIcon>
    <AddCircle style={{height:48,width:48}} />
  </ListItemIcon>,
  description: ''
}

export class CreateSource extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      previewDisplayTemplate: 1,
      fullDisplayTemplate: 2,
      previewDisplayTemplateIndex: 0,
      fullDisplayTemplateIndex: 0,
      fullDisplayMappings: [],
      previewDisplayMappings: [],
      scores: [],
      sourceFilter: '',
      dataTypeFilter: '',
      title: '',
      storageUse: 0,
      docsCount: 0,
      isLoading: true,
      activity: []
    }
  }

  componentDidMount() {

  }

  saveMapping = () => {

    var source = { 
      Title: this.state.title,
      SourceFilter: this.state.source
    }

    this.props.dispatch(showSnackbar( 'Saving...'));
    this.props.sourceService.createSource(source).then(() => {

        this.props.dispatch(showSnackbar( 'Saved!'));
        this.props.goTo({ pathname: '/admin/sources' })
    })
  }

    onChange = (name, newValue) => {
        this.setState({ [name]: newValue });
    }

  render() {
    const { classes,t } = this.props;

    return (<div data-intrcm-id="createSource_4verp89i">
      <AppContent >
        <SingleColumnView>
            <Paper className={classes.paper} elevation={1}>
                <Grid container spacing={16} justify="space-between">
                    <Grid item md={8}>
                        <Header {...pageTitle} classes={classes}/>
                    </Grid>
                    <Grid md={4}>
                        <Button variant="raised" onClick={this.saveMapping} className={classes.buttonIc}>{t('Save changes')}</Button>
                    </Grid>
                </Grid>
                <Divider className={classes.divid} />
            
                <Grid>
                    <Grid md={10}>
                        <div data-intrcm-id="createSource_w38a5o08" >
                            <Grid>
                                <Grid md={12}>
                                    <TextField
                                        id="text-field-title"
                                        label={t("Source title")}
                                        onChange={event => this.onChange("title", event.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid>
                                <Grid md={12}>
                                    <TextField
                                        id="text-field-source"
                                        label={t("Source")}
                                        onChange={event => this.onChange("source", event.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
          </Paper>
        </SingleColumnView>
      </AppContent>
    </div>);
  }

}

const mapStateToProps = (state) => ({
  ...state.services,
  globalData: state.globalData
})

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
    goTo: path => { dispatch(push(path)) }
  }
}

export default compose(withStyles(styles),
  withTranslation('admin'),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(CreateSource);